import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Login from "./pages/admin/login/Login";
import Home from "./pages/home/Home";
import SignUp from "./pages/admin/signUp/SignUp";
import Layout from "./pages/admin/layout/Layout";
import AllProducts from "./pages/admin/products/AllProducts";
import AddProducts from "./pages/admin/products/AddProducts";
import Dashboard from "./pages/admin/dashboard/Dashboard";
import EditProduct from "./pages/admin/products/EditProduct";
import About from "./pages/about/About";
import ProductListing from "./pages/products/ProductListing";
import ProductDetail from "./pages/products/ProductDetail";
import UserLogin from "./pages/userAuth/UserLogin";
import UserSignup from "./pages/userAuth/UserSignup";
import OrganizationChart from "./pages/organization/OrganizationChart";
import ScrollToTop from "./components/scrollTop/ScrollToTop";
import Services from "./pages/services/Services";
import Contact from "./pages/contact/Contact";
import TermsCondition from "./pages/terms/TermsCondition";
import PrivacyPolicy from "./pages/terms/PrivacyPolicy";
import PageTitle from "./components/title/PageTItle";
import { ProductProvider } from "./Contexts/ProductContext";
import Interests from "./pages/admin/interests/Interests";
import InterestDetail from "./pages/admin/interests/InterestDetail";
import List from "./pages/admin/customers/List";

function App() {
  return (
    <div className="h-full">
      <ScrollToTop />
      <ProductProvider>
        <Routes>
          <Route path="/" element={<PageTitle title="Home - AGA Construction Equipment & Machinery Trading LLC"><Home /></PageTitle>}></Route>
          <Route path="/about-us" element={<PageTitle title="About Us - AGA Construction Equipment & Machinery Trading LLC"><About /></PageTitle>}></Route>
          <Route path="/organizational-chart" element={<PageTitle title="Organizational Chart - AGA Construction Equipment & Machinery Trading LLC"><OrganizationChart /></PageTitle>}></Route>
          <Route path="/productlists" element={<PageTitle title="Products - AGA Construction Equipment & Machinery Trading LLC"><ProductListing /></PageTitle>}></Route>
          <Route path="/productDetail/:title/:id" element={<PageTitle title="Product Detail - AGA Construction Equipment & Machinery Trading LLC"><ProductDetail /></PageTitle>} />
          <Route path="/services" element={<PageTitle title="Services - AGA Construction Equipment & Machinery Trading LLC"><Services /></PageTitle>} />
          <Route path="/contact-us" element={<PageTitle title="Contact Us - AGA Construction Equipment & Machinery Trading LLC"><Contact /></PageTitle>} />
          <Route path="/terms-conditions" element={<PageTitle title="Terms & Conditions - AGA Construction Equipment & Machinery Trading LLC"><TermsCondition /></PageTitle>} />
          <Route path="/privacy-policy" element={<PageTitle title="Privacy Policy - AGA Construction Equipment & Machinery Trading LLC"><PrivacyPolicy /></PageTitle>} />
          <Route path="/login" element={<PageTitle title="User Login - AGA Construction Equipment & Machinery Trading LLC"><UserLogin /></PageTitle>} />
          <Route path="/signUp" element={<PageTitle title="User SignUp - AGA Construction Equipment & Machinery Trading LLC"><UserSignup /></PageTitle>} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/signUp" element={<SignUp />} />
          <Route path="/admin/dashboard" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<AllProducts />} />
            <Route path="interests" element={<Interests />} />
            <Route path="detailInterest/:id" element={<InterestDetail />} />
            <Route path="addproduct" element={<AddProducts />} />
            <Route path="editproduct/:id" element={<EditProduct />} />
            <Route path="customers" element={<List />} />
          </Route>
        </Routes>
      </ProductProvider>
    </div>
  );
}

export default App;
